import axios from 'axios';
import { store } from '../redux/store';
import { logout } from 'redux/slices/auth/authSlice';

const withAuth = (headers = {}) => {
    const accessToken = localStorage.getItem('userToken');
    return {
        ...headers,
        Authorization: `Token ${accessToken}`
    };
};

const base = (method, url, data = {}, headers = {}, secure = true) => {
    if (secure) {
        return axios({
            method,
            url,
            data,
            headers: withAuth(headers)
        }).catch((err) => {
            if (err.response.status === 401) {
                store.dispatch(logout());
            }
            throw err;
        });
    } else {
        return axios({
            method,
            url,
            data,
            headers
        });
    }
};

const ApiHelper = {};

const methods = ['get', 'post', 'put', 'patch', 'delete'];

methods.forEach((method) => {
    ApiHelper[method] = base.bind(null, method);
});

export default ApiHelper;
